const PauseAudioIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.width ? props?.width : "23"}
      height={props?.height ? props?.height : "23"}
      fill="none"
      viewBox="0 0 34 34"
    >
      <rect fill={props?.selected ? "white":"#EAD9FF"} x="0.5" y="0.5" width="32" height="32" rx="16" />
      <rect x="0.5" y="0.5" width="32" height="32" rx="16" stroke="#7426D5"/>
      <path d="M20.5 9.5H18.8333C18.3731 9.5 18 9.8731 18 10.3333V22C18 22.4602 18.3731 22.8333 18.8333 22.8333H20.5C20.9602 22.8333 21.3333 22.4602 21.3333 22V10.3333C21.3333 9.8731 20.9602 9.5 20.5 9.5Z" stroke="#6D1AD3" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.5 9.83325H11.8333C11.3731 9.83325 11 10.2063 11 10.6666V22.3333C11 22.7935 11.3731 23.1666 11.8333 23.1666H13.5C13.9602 23.1666 14.3333 22.7935 14.3333 22.3333V10.6666C14.3333 10.2063 13.9602 9.83325 13.5 9.83325Z" stroke="#6D1AD3" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default PauseAudioIcon;